import React from 'react';
import SvgIcon from '@mui/material/SvgIcon';

export default props => (
    <SvgIcon viewBox="0 0 170 240" {...props}>
        <path
            d="M97.53,1.38c5.34,1,9.38,1.62,14.17,3.11,5.33,1.66,10.75,3.55,15.48,6.42,4.1,3.72,5.41,7.42,6.53,9.34-.37.46.09.09-.28.55H36.06c.05-5.18,3.29-8.13,7.08-10.52,8.65-5.47,18.53-6.84,28.59-8.55,1.92-.35,8.84-1.21,11.44-1.23,4.68-.05,10.82.31,14.37.88Z"
            fill="none"
            stroke="currentColor"
            strokeWidth={10} // cap
        />
        <path
            d="M4.73,70.96c-.18,1.28,1.23-9.56,5.57-20.42,6.19-15.52,20.1-24.55,37.6-24.38,24.49.24,49.01.82,73.47-.19,18.79-.77,36.32,14.36,40.42,31.5,1.03,4.32,1.61,8.74,2.5,13.74-52.6,5.51-107.17,5.01-159.56-.26"
            fill="none"
            stroke="currentColor"
            strokeWidth={15} // top
        />
        <path
            d="M4.73,77.75c10.77.49,23.72,1.86,34.51,2.46,40.45,2.25,79.12,2.54,119.45-1.48,3.2-.32,3.68-.87,5.28-.79-.43,4.02-.64,8.65-1.38,12.31-.17.86-10.03,1.76-11.24,1.88-10.58,1.06-13.26,1.39-23.87,2.02-37.12,2.19-74.2.99-111.25-1.84-2.82-.22-5.62-.63-8.86-.94-1.32-3.45-2.64-8.79-2.64-13.62Z"
            fill="none"
            stroke="currentColor"
            strokeWidth={10} // band
        />
        <path
            d="M51.37,228.12c-9.4-3.24-13.61-8.82-13.64-19.1-.06-22.67-7.06-44.1-14.15-65.4-4.82-14.47-9.45-29-14.14-43.51-.19-.6-.49-1.06-.94-2.63,50.56,5.06,101.4,4.95,152.63,0-1.68,5.88-3.03,11.06-4.65,16.15-6.58,20.69-14,41.15-19.6,62.1-3.31,12.39-4.12,25.5-5.42,38.35-.49,4.86-2.25,8.06-6.2,10.56-7.99,5.07-17.01,6.76-26.11,7.35-15.93,1.03-31.93,1.45-47.78-3.89Z"
            fill="none"
            stroke="currentColor"
            strokeWidth={15} // bottom
        />
    </SvgIcon>
);
